import { IContact } from 'src/api/models/Organization';

/**
 * @registry Parses a workflow record's persisted `externalContact` into an IContact.
 * The field is stored as a JSON string but may already be an object; returns null when
 * absent or unparseable.
 */
export const parseExternalContact = (raw: unknown): IContact | null => {
  if (!raw) return null;
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw) as IContact;
    } catch {
      return null;
    }
  }
  return raw as IContact;
};
